// LIST (Don't really think these should belong here)
export const SORT_ASC = 'asc';
export const SORT_DESC = 'desc';

// LOCALE
export const CHANGE_LOCALE = 'CHANGE_LOCALE';

// API Keys
export const FETCH_API_KEYS = 'FETCH_API_KEYS';
export const FETCH_API_KEYS_FAILURE = 'FETCH_API_KEYS_FAILURE';
export const FETCH_API_KEYS_SUCCESS = 'FETCH_API_KEYS_SUCCESS';

export const API_KEY_LIST_FILTER_UPDATE = 'API_KEY_LIST_FILTER_UPDATE';
export const API_KEY_LIST_PAGE = 'API_KEY_LIST_PAGE';
export const API_KEY_LIST_SORT = 'API_KEY_LIST_SORT';

export const FETCH_API_KEY = 'FETCH_API_KEY';
export const FETCH_API_KEY_FAILURE = 'FETCH_API_KEY_FAILURE';
export const FETCH_API_KEY_SUCCESS = 'FETCH_API_KEY_SUCCESS';

export const CLEAR_API_KEY_TOKEN = 'CLEAR_API_KEY_TOKEN';
export const CREATE_API_KEY = 'CREATE_API_KEY';
export const CREATE_API_KEY_FAILURE = 'CREATE_API_KEY_FAILURE';
export const CREATE_API_KEY_MODAL_SUCCESS = 'CREATE_API_KEY_MODAL_SUCCESS';
export const CREATE_API_KEY_SUCCESS = 'CREATE_API_KEY_SUCCESS';

export const UPDATE_API_KEY = 'UPDATE_API_KEY';
export const UPDATE_API_KEY_FAILURE = 'UPDATE_API_KEY_FAILURE';
export const UPDATE_API_KEY_SUCCESS = 'UPDATE_API_KEY_SUCCESS';

export const DELETE_API_KEY = 'DELETE_API_KEY';
export const DELETE_API_KEY_FAILURE = 'DELETE_API_KEY_FAILURE';
export const DELETE_API_KEY_SUCCESS = 'DELETE_API_KEY_SUCCESS';

// Authorisation
export const AUTH_LOGIN = 'AUTH_LOGIN';
export const AUTH_LOGIN_FAILURE = 'AUTH_LOGIN_FAILURE';
export const AUTH_LOGIN_SUCCESS = 'AUTH_LOGIN_SUCCESS';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const AUTH_LOGOUT_FAILURE = 'AUTH_LOGOUT_FAILURE';
export const AUTH_LOGOUT_SUCCESS = 'AUTH_LOGOUT_SUCCESS';

// Categories
export const FETCH_CATEGORIES = 'FETCH_CATEGORIES';
export const FETCH_CATEGORIES_FAILURE = 'FETCH_CATEGORIES_FAILURE';
export const FETCH_CATEGORIES_SUCCESS = 'FETCH_CATEGORIES_SUCCESS';

// Category
export const FETCH_CATEGORY = 'FETCH_CATEGORY';
export const FETCH_CATEGORY_FAILURE = 'FETCH_CATEGORY_FAILURE';
export const FETCH_CATEGORY_SUCCESS = 'FETCH_CATEGORY_SUCCESS';

// Subcategory
export const FETCH_SUBCATEGORIES = 'FETCH_SUBCATEGORIES';
export const FETCH_SUBCATEGORIES_FAILURE = 'FETCH_SUBCATEGORIES_FAILURE';
export const FETCH_SUBCATEGORIES_SUCCESS = 'FETCH_SUBCATEGORIES_SUCCESS';

export const SUBCATEGORIES_LIST_PAGE = 'SUBCATEGORIES_LIST_PAGE';
export const SUBCATEGORIES_LIST_SORT = 'SUBCATEGORIES_LIST_SORT';

// Subcategory
export const FETCH_SUBCATEGORY = 'FETCH_SUBCATEGORY';
export const FETCH_SUBCATEGORY_FAILURE = 'FETCH_SUBCATEGORY_FAILURE';
export const FETCH_SUBCATEGORY_SUCCESS = 'FETCH_SUBCATEGORY_SUCCESS';

// Subcategory Localisation
export const FETCH_SUBCATEGORY_LOCALISATION = 'FETCH_SUBCATEGORY_LOCALISATION';
export const FETCH_SUBCATEGORY_LOCALISATION_FAILURE = 'FETCH_SUBCATEGORY_LOCALISATION_FAILURE';
export const FETCH_SUBCATEGORY_LOCALISATION_SUCCESS = 'FETCH_SUBCATEGORY_LOCALISATION_SUCCESS';

// Create Subcategory
export const CREATE_SUBCATEGORY = 'CREATE_SUBCATEGORY';
export const CREATE_SUBCATEGORY_FAILURE = 'CREATE_SUBCATEGORY_FAILURE';

// Create Subcategory Localisation
export const CREATE_SUBCATEGORY_LOCALISATION = 'CREATE_SUBCATEGORY_LOCALISATION';
export const CREATE_SUBCATEGORY_LOCALISATION_FAILURE = 'CREATE_SUBCATEGORY_LOCALISATION_FAILURE';
export const CREATE_SUBCATEGORY_LOCALISATION_SUCCESS = 'CREATE_SUBCATEGORY_LOCALISATION_SUCCESS';

// Update Subcategory
export const UPDATE_SUBCATEGORY = 'UPDATE_SUBCATEGORY';
export const UPDATE_SUBCATEGORY_FAILURE = 'UPDATE_SUBCATEGORY_FAILURE';

// Update Subcategory Localisation
export const UPDATE_SUBCATEGORY_LOCALISATION = 'UPDATE_SUBCATEGORY_LOCALISATION';
export const UPDATE_SUBCATEGORY_LOCALISATION_FAILURE = 'UPDATE_SUBCATEGORY_LOCALISATION_FAILURE';
export const UPDATE_SUBCATEGORY_LOCALISATION_SUCCESS = 'UPDATE_SUBCATEGORY_LOCALISATION_SUCCESS';

// Delete Subcategory
export const DELETE_SUBCATEGORY = 'DELETE_SUBCATEGORY';
export const DELETE_SUBCATEGORY_FAILURE = 'DELETE_SUBCATEGORY_FAILURE';
export const DELETE_SUBCATEGORY_SUCCESS = 'DELETE_SUBCATEGORY_SUCCESS';

// Options
export const FETCH_OPTION = 'FETCH_OPTION';
export const FETCH_OPTION_FAILURE = 'FETCH_OPTION_FAILURE';
export const FETCH_OPTION_SUCCESS = 'FETCH_OPTION_SUCCESS';

// User Impersonation
export const CREATE_USER_IMPERSONATION = 'CREATE_USER_IMPERSONATION';
export const CREATE_USER_IMPERSONATION_FAILURE = 'CREATE_USER_IMPERSONATION_FAILURE';
export const DELETE_USER_IMPERSONATION = 'DELETE_USER_IMPERSONATION';
export const DELETE_USER_IMPERSONATION_FAILURE = 'DELETE_USER_IMPERSONATION_FAILURE';

// Order
export const ORDER_RECENT_ALTERATION = 'ORDER_RECENT_ALTERATION';

export const FETCH_ORDER = 'FETCH_ORDER';
export const FETCH_ORDER_FAILURE = 'FETCH_ORDER_FAILURE';
export const FETCH_ORDER_SUCCESS = 'FETCH_ORDER_SUCCESS';

export const UPDATE_ORDER = 'UPDATE_ORDER';
export const UPDATE_ORDER_FAILURE = 'UPDATE_ORDER_FAILURE';
export const UPDATE_ORDER_SUCCESS = 'UPDATE_ORDER_SUCCESS';

export const AMEND_ORDER = 'AMEND_ORDER';
export const AMEND_ORDER_FAILURE = 'AMEND_ORDER_FAILURE';
export const AMEND_ORDER_SUCCESS = 'AMEND_ORDER_SUCCESS';

export const AMEND_BOOKING = 'AMEND_BOOKING';
export const AMEND_BOOKING_FAILURE = 'AMEND_BOOKING_FAILURE';
export const AMEND_BOOKING_SUCCESS = 'AMEND_BOOKING_SUCCESS';

export const AMEND_BOOKING_LOADING_OFF = 'AMEND_BOOKING_LOADING_OFF';
export const AMEND_BOOKING_LOADING_ON = 'AMEND_BOOKING_LOADING_ON';

export const AMEND_BOOKING_RESERVATION = 'AMEND_BOOKING_RESERVATION';
export const AMEND_BOOKING_RESERVATION_FAILURE = 'AMEND_BOOKING_RESERVATION_FAILURE';

export const AMEND_BOOKING_RESERVATION_LOADING_OFF = 'AMEND_BOOKING_RESERVATION_LOADING_OFF';
export const AMEND_BOOKING_RESERVATION_LOADING_ON = 'AMEND_BOOKING_RESERVATION_LOADING_ON';

export const AMEND_BOOKING_RESERVATION_MESSAGE = 'AMEND_BOOKING_RESERVATION_MESSAGE';
export const AMEND_BOOKING_RESERVATION_PHASE = 'AMEND_BOOKING_RESERVATION_PHASE';
export const AMEND_BOOKING_RESERVATION_PRICES_EMPTY = 'AMEND_BOOKING_RESERVATION_PRICES_EMPTY';
export const AMEND_BOOKING_RESERVATION_RESET = 'AMEND_BOOKING_RESERVATION_RESET';
export const AMEND_BOOKING_RESERVATION_SELECTED_QUOTE = 'AMEND_BOOKING_RESERVATION_SELECTED_QUOTE';
export const AMEND_BOOKING_RESERVATION_SUCCESS = 'AMEND_BOOKING_RESERVATION_SUCCESS';

export const CREATE_BOOKING_RESERVATION_TRANSACTION = 'CREATE_BOOKING_RESERVATION_TRANSACTION';
export const CREATE_BOOKING_RESERVATION_TRANSACTION_FAILURE = 'CREATE_BOOKING_RESERVATION_TRANSACTION_FAILURE';
export const CREATE_BOOKING_RESERVATION_TRANSACTION_SUCCESS = 'CREATE_BOOKING_RESERVATION_TRANSACTION_SUCCESS';

export const FETCH_BOOKING_RESERVATIONS = 'FETCH_BOOKING_RESERVATIONS';
export const FETCH_BOOKING_RESERVATIONS_FAILURE = 'FETCH_BOOKING_RESERVATIONS_FAILURE';
export const FETCH_BOOKING_RESERVATIONS_SUCCESS = 'FETCH_BOOKING_RESERVATIONS_SUCCESS';

export const FETCH_BOOKING_RESERVATION_PRICES = 'FETCH_BOOKING_RESERVATION_PRICES';
export const FETCH_BOOKING_RESERVATION_PRICES_FAILURE = 'FETCH_BOOKING_RESERVATION_PRICES_FAILURE';
export const FETCH_BOOKING_RESERVATION_PRICES_SUCCESS = 'FETCH_BOOKING_RESERVATION_PRICES_SUCCESS';

export const FETCH_TRANSACTION_QUOTES = 'FETCH_TRANSACTION_QUOTES';
export const FETCH_TRANSACTION_QUOTES_FAILURE = 'FETCH_TRANSACTION_QUOTES_FAILURE';
export const FETCH_TRANSACTION_QUOTES_SUCCESS = 'FETCH_TRANSACTION_QUOTES_SUCCESS';

export const SELECT_TRANSACTION_QUOTE = 'SELECT_TRANSACTION_QUOTE';

export const CREATE_TRANSACTION_PAYMENT = 'CREATE_TRANSACTION_PAYMENT';
export const CREATE_TRANSACTION_PAYMENT_FAILURE = 'CREATE_TRANSACTION_PAYMENT_FAILURE';
export const CREATE_TRANSACTION_PAYMENT_SUCCESS = 'CREATE_TRANSACTION_PAYMENT_SUCCESS';

// Order receipts
export const FETCH_ORDER_RECEIPT = 'FETCH_ORDER_RECEIPT';
export const FETCH_ORDER_RECEIPT_SUCCESS = 'FETCH_ORDER_RECEIPT_SUCCESS';
export const FETCH_ORDER_RECEIPT_FAILURE = 'FETCH_ORDER_RECEIPT_FAILURE';

// Order Activities
export const FETCH_ORDER_BOOKING_ACTIVITIES = 'FETCH_ORDER_BOOKING_ACTIVITIES';
export const FETCH_ORDER_BOOKING_ACTIVITIES_FAILURE = 'FETCH_ORDER_BOOKING_ACTIVITIES_FAILURE';
export const FETCH_ORDER_BOOKING_ACTIVITIES_SUCCESS = 'FETCH_ORDER_BOOKING_ACTIVITIES_SUCCESS';

// Retry Order
export const RETRY_ORDER_REQUEST = 'RETRY_ORDER_REQUEST';
export const RETRY_ORDER_FAILURE = 'RETRY_ORDER_FAILURE';
export const RETRY_ORDER_SUCCESS = 'RETRY_ORDER_SUCCESS';

// Payment-slip download
export const PAYMENT_SLIP_DOWNLOAD_FAILURE = 'PAYMENT_SLIP_DOWNLOAD_FAILURE';

// Payment-slip send
export const PAYMENT_SLIP_ORDER_FAILURE = 'PAYMENT_SLIP_ORDER_FAILURE';
export const PAYMENT_SLIP_ORDER_SUCCESS = 'PAYMENT_SLIP_ORDER_SUCCESS';

// Voucher Download
export const VOUCHER_DOWNLOAD_FAILURE = 'VOUCHER_DOWNLOAD_FAILURE';

// Voucher Order
export const VOUCHER_ORDER_FAILURE = 'VOUCHER_ORDER_FAILURE';
export const VOUCHER_ORDER_SUCCESS = 'VOUCHER_ORDER_SUCCESS';

// Patch Data
export const PATCH_DATA = 'PATCH_DATA';
export const PATCH_DATA_SUCCESS = 'PATCH_DATA_SUCCESS';

// Order cancel
export const ORDER_CANCEL = 'ORDER_CANCEL';
export const ORDER_CANCEL_SUCCESS = 'ORDER_CANCEL_SUCCESS';

export const FETCH_PRODUCT_LOCALISATION = 'FETCH_PRODUCT_LOCALISATION';
export const FETCH_PRODUCT_LOCALISATION_FAILURE = 'FETCH_PRODUCT_LOCALISATION_FAILURE';
export const FETCH_PRODUCT_LOCALISATION_SUCCESS = 'FETCH_PRODUCT_LOCALISATION_SUCCESS';

export const UPDATE_PRODUCT_LOCALISATION = 'UPDATE_PRODUCT_LOCALISATION';
export const UPDATE_PRODUCT_LOCALISATION_FAILURE = 'UPDATE_PRODUCT_LOCALISATION_FAILURE';
export const UPDATE_PRODUCT_LOCALISATION_SUCCESS = 'UPDATE_PRODUCT_LOCALISATION_SUCCESS';

export const UPDATE_PRODUCT_ACTIVITY_FAILURE = 'UPDATE_PRODUCT_ACTIVITY_FAILURE';
export const UPDATE_PRODUCT_ACTIVITY_SUCCESS = 'UPDATE_PRODUCT_ACTIVITY_SUCCESS';

export const UPDATE_PRODUCT_RESOURCE = 'UPDATE_PRODUCT_RESOURCE';
export const UPDATE_PRODUCT_RESOURCE_FAILURE = 'UPDATE_PRODUCT_RESOURCE_FAILURE';
export const UPDATE_PRODUCT_RESOURCE_SUCCESS = 'UPDATE_PRODUCT_RESOURCE_SUCCESS';

export const UPDATE_PRODUCT_LOCATION = 'UPDATE_PRODUCT_LOCATION';
export const UPDATE_PRODUCT_LOCATION_FAILURE = 'UPDATE_PRODUCT_LOCATION_FAILURE';
export const UPDATE_PRODUCT_LOCATION_SUCCESS = 'UPDATE_PRODUCT_LOCATION_SUCCESS';

export const FETCH_PRODUCT_AVAILABILITY = 'FETCH_PRODUCT_AVAILABILITY';
export const FETCH_PRODUCT_AVAILABILITY_FAILURE = 'FETCH_PRODUCT_AVAILABILITY_FAILURE';
export const FETCH_PRODUCT_AVAILABILITY_SUCCESS = 'FETCH_PRODUCT_AVAILABILITY_SUCCESS';

export const FETCH_ONE_PRODUCT_RELATED = '[Product Related] - Fetch';
export const FETCH_ONE_PRODUCT_RELATED_FAILURE = '[Product Related] - Fetch Failure';
export const FETCH_ONE_PRODUCT_RELATED_SUCCESS = '[Product Related] - Fetch Success';

export const CREATE_PRODUCT_RELATED = '[Product Related] - Create';
export const CREATE_PRODUCT_RELATED_FAILURE = '[Product Related] - Create Failure';
export const CREATE_PRODUCT_RELATED_SUCCESS = '[Product Related] - Create Success';

export const DELETE_PRODUCT_RELATED = '[Product Related] - Delete';
export const DELETE_PRODUCT_RELATED_FAILURE = '[Product Related] - Delete Failure';
export const DELETE_PRODUCT_RELATED_SUCCESS = '[Product Related] - Delete Success';

export const PRODUCT_RELATED_LIST_FILTER_UPDATE = '[Product Related] - List Filter';
export const PRODUCT_RELATED_LIST_FILTER_CATEGORY = '[Product Related] - List Filter Category';
export const PRODUCT_RELATED_LIST_PAGE = '[Product Related] - List Page';
export const PRODUCT_RELATED_LIST_SORT = '[Product Related] - List Sort';

export const SAVE_PRODUCT_CONFIGURATON = 'SAVE_PRODUCT_CONFIGURATON';
export const SAVE_PRODUCT_CONFIGURATON_FAILURE = 'SAVE_PRODUCT_CONFIGURATON_FAILURE';
export const SAVE_PRODUCT_CONFIGURATON_SUCCESS = 'SAVE_PRODUCT_CONFIGURATON_SUCCESS';

export const ADD_PRODUCT_IMAGE = 'ADD_PRODUCT_IMAGE';
export const ADD_PRODUCT_IMAGE_FAILURE = 'ADD_PRODUCT_IMAGE_FAILURE';
export const ADD_PRODUCT_IMAGE_SUCCESS = 'ADD_PRODUCT_IMAGE_SUCCESS';

export const DELETE_PRODUCT_IMAGE = 'DELETE_PRODUCT_IMAGE';
export const DELETE_PRODUCT_IMAGE_FAILURE = 'DELETE_PRODUCT_IMAGE_FAILURE';
export const DELETE_PRODUCT_IMAGE_SUCCESS = 'DELETE_PRODUCT_IMAGE_SUCCESS';

export const FETCH_PRODUCT_IMAGES = 'FETCH_PRODUCT_IMAGES';
export const FETCH_PRODUCT_IMAGES_FAILURE = 'FETCH_PRODUCT_IMAGES_FAILURE';
export const FETCH_PRODUCT_IMAGES_SUCCESS = 'FETCH_PRODUCT_IMAGES_SUCCESS';

export const FETCH_PRODUCT_OCCUPANCY = 'FETCH_PRODUCT_OCCUPANCY';
export const FETCH_PRODUCT_OCCUPANCY_FAILURE = 'FETCH_PRODUCT_OCCUPANCY_FAILURE';
export const FETCH_PRODUCT_OCCUPANCY_SUCCESS = 'FETCH_PRODUCT_OCCUPANCY_SUCCESS';

export const SET_HIGHLIGHTED_PRODUCT_IMAGE = 'SET_HIGHLIGHTED_PRODUCT_IMAGE';
export const SET_HIGHLIGHTED_PRODUCT_IMAGE_SUCCESS = 'SET_HIGHLIGHTED_PRODUCT_IMAGE_SUCCESS';
export const SET_HIGHLIGHTED_PRODUCT_IMAGE_FAILURE = 'SET_HIGHLIGHTED_PRODUCT_IMAGE_FAILURE';

export const UPLOAD = 'UPLOAD';

export const DELETE_LOGO_FAILURE = 'DELETE_LOGO_FAILURE';
export const DELETE_LOGO_REQUEST = 'DELETE_LOGO_REQUEST';
export const DELETE_LOGO_SUCCESS = 'DELETE_LOGO_SUCCESS';

export const FETCH_CAMPAIGNS = 'FETCH_CAMPAIGNS';
export const FETCH_CAMPAIGNS_ACCUMULATED = 'FETCH_CAMPAIGNS_ACCUMULATED';
export const FETCH_CAMPAIGNS_FAILURE = 'FETCH_CAMPAIGNS_FAILURE';
export const FETCH_CAMPAIGNS_SUCCESS = 'FETCH_CAMPAIGNS_SUCCESS';

export const FETCH_CAMPAIGN = 'FETCH_CAMPAIGN';
export const FETCH_CAMPAIGN_ACCUMULATED = 'FETCH_CAMPAIGN_ACCUMULATED';
export const FETCH_CAMPAIGN_FAILURE = 'FETCH_CAMPAIGN_FAILURE';
export const FETCH_CAMPAIGN_SUCCESS = 'FETCH_CAMPAIGN_SUCCESS';

export const CREATE_CAMPAIGN = 'CREATE_CAMPAIGN';
export const CREATE_CAMPAIGN_FAILURE = 'CREATE_CAMPAIGN_FAILURE';
export const CREATE_CAMPAIGN_SUCCESS = 'CREATE_CAMPAIGN_SUCCESS';

export const UPDATE_CAMPAIGN = 'UPDATE_CAMPAIGN';
export const UPDATE_CAMPAIGN_FAILURE = 'UPDATE_CAMPAIGN_FAILURE';
export const UPDATE_CAMPAIGN_SUCCESS = 'UPDATE_CAMPAIGN_SUCCESS';

export const DELETE_CAMPAIGN = 'DELETE_CAMPAIGN';
export const DELETE_CAMPAIGN_FAILURE = 'DELETE_CAMPAIGN_FAILURE';
export const DELETE_CAMPAIGN_SUCCESS = 'DELETE_CAMPAIGN_SUCCESS';

export const CAMPAIGN_LIST_FILTER_UPDATE = 'CAMPAIGN_LIST_FILTER_UPDATE';
export const CAMPAIGN_LIST_FILTER_CATEGORY = 'CAMPAIGN_LIST_FILTER_CATEGORY';
export const CAMPAIGN_LIST_PAGE = 'CAMPAIGN_LIST_PAGE';
export const CAMPAIGN_LIST_SORT = 'CAMPAIGN_LIST_SORT';

// Dashboard Stats
export const FETCH_DASHBOARD_STATS = 'FETCH_DASHBOARD_STATS';
export const FETCH_DASHBOARD_STATS_FAILURE = 'FETCH_DASHBOARD_STATS_SUCCESS';
export const FETCH_DASHBOARD_STATS_SUCCESS = 'FETCH_DASHBOARD_STATS_SUCCESS';

// Paths
export const CLEAR_PATH = 'CLEAR_PATH';
export const SET_PATH = 'SET_PATH';

// Points of interest
export const FETCH_POINTS_OF_INTEREST = 'FETCH_POINTS_OF_INTEREST';
export const FETCH_POINTS_OF_INTEREST_FAILURE = 'FETCH_POINTS_OF_INTEREST_FAILURE';
export const FETCH_POINTS_OF_INTEREST_SUCCESS = 'FETCH_POINTS_OF_INTEREST_SUCCESS';

export const POINTS_OF_INTEREST_LIST_FILTER_UPDATE = 'POINTS_OF_INTEREST_LIST_FILTER_UPDATE';
export const POINTS_OF_INTEREST_LIST_FILTER_CATEGORY = 'POINTS_OF_INTEREST_LIST_FILTER_CATEGORY';
export const POINTS_OF_INTEREST_LIST_PAGE = 'POINTS_OF_INTEREST_LIST_PAGE';
export const POINTS_OF_INTEREST_LIST_SORT = 'POINTS_OF_INTEREST_LIST_SORT';

export const FETCH_POINT_OF_INTEREST = 'FETCH_POINT_OF_INTEREST';
export const FETCH_POINT_OF_INTEREST_FAILURE = 'FETCH_POINT_OF_INTEREST_FAILURE';
export const FETCH_POINT_OF_INTEREST_SUCCESS = 'FETCH_POINT_OF_INTEREST_SUCCESS';

export const FETCH_POINT_OF_INTEREST_LOCALISATION = 'FETCH_POINT_OF_INTEREST_LOCALISATION';
export const FETCH_POINT_OF_INTEREST_LOCALISATION_FAILURE = 'FETCH_POINT_OF_INTEREST_LOCALISATION_FAILURE';
export const FETCH_POINT_OF_INTEREST_LOCALISATION_SUCCESS = 'FETCH_POINT_OF_INTEREST_LOCALISATION_SUCCESS';

export const CREATE_POINT_OF_INTEREST = 'CREATE_POINT_OF_INTEREST';
export const CREATE_POINT_OF_INTEREST_FAILURE = 'CREATE_POINT_OF_INTEREST_FAILURE';

export const CREATE_POINT_OF_INTEREST_LOCALISATION = 'CREATE_POINT_OF_INTEREST_LOCALISATION';
export const CREATE_POINT_OF_INTEREST_LOCALISATION_FAILURE = 'CREATE_POINT_OF_INTEREST_LOCALISATION_FAILURE';
export const CREATE_POINT_OF_INTEREST_LOCALISATION_SUCCESS = 'CREATE_POINT_OF_INTEREST_LOCALISATION_SUCCESS';

export const UPDATE_POINT_OF_INTEREST = 'UPDATE_POINT_OF_INTEREST';
export const UPDATE_POINT_OF_INTEREST_FAILURE = 'UPDATE_POINT_OF_INTEREST_FAILURE';

export const UPDATE_POINT_OF_INTEREST_LOCALISATION = 'UPDATE_POINT_OF_INTEREST_LOCALISATION';
export const UPDATE_POINT_OF_INTEREST_LOCALISATION_FAILURE = 'UPDATE_POINT_OF_INTEREST_LOCALISATION_FAILURE';
export const UPDATE_POINT_OF_INTEREST_LOCALISATION_SUCCESS = 'UPDATE_POINT_OF_INTEREST_LOCALISATION_SUCCESS';

export const DELETE_POINT_OF_INTEREST = 'DELETE_POINT_OF_INTEREST';
export const DELETE_POINT_OF_INTEREST_FAILURE = 'DELETE_POINT_OF_INTEREST_FAILURE';
export const DELETE_POINT_OF_INTEREST_SUCCESS = 'DELETE_POINT_OF_INTEREST_SUCCESS';

export const CREATE_POINT_OF_INTEREST_IMAGE = 'CREATE_POINT_OF_INTEREST_IMAGE';
export const CREATE_POINT_OF_INTEREST_IMAGE_FAILURE = 'CREATE_POINT_OF_INTEREST_IMAGE_FAILURE';
export const CREATE_POINT_OF_INTEREST_IMAGE_SUCCESS = 'CREATE_POINT_OF_INTEREST_IMAGE_SUCCESS';

export const DELETE_POINT_OF_INTEREST_IMAGE = 'DELETE_POINT_OF_INTEREST_IMAGE';
export const DELETE_POINT_OF_INTEREST_IMAGE_FAILURE = 'DELETE_POINT_OF_INTEREST_IMAGE_FAILURE';
export const DELETE_POINT_OF_INTEREST_IMAGE_SUCCESS = 'DELETE_POINT_OF_INTEREST_IMAGE_SUCCESS';

export const FETCH_POINT_OF_INTEREST_IMAGES = 'FETCH_POINT_OF_INTEREST_IMAGES';
export const FETCH_POINT_OF_INTEREST_IMAGES_FAILURE = 'FETCH_POINT_OF_INTEREST_IMAGES_FAILURE';
export const FETCH_POINT_OF_INTEREST_IMAGES_SUCCESS = 'FETCH_POINT_OF_INTEREST_IMAGES_SUCCESS';

export const SET_HIGHLIGHTED_POI_IMAGE = 'SET_HIGHLIGHTED_POI_IMAGE';
export const SET_HIGHLIGHTED_POI_IMAGE_SUCCESS = 'SET_HIGHLIGHTED_POI_IMAGE_SUCCESS';
export const SET_HIGHLIGHTED_POI_IMAGE_FAILURE = 'SET_HIGHLIGHTED_POI_IMAGE_FAILURE';

export const CREATE_POINT_OF_INTEREST_IMPORT = 'CREATE_POINT_OF_INTEREST_IMPORT';
export const CREATE_POINT_OF_INTEREST_IMPORT_FAILURE = 'CREATE_POINT_OF_INTEREST_IMPORT_FAILURE';

// Property groups
export const FETCH_PROPERTYGROUPS = 'FETCH_PROPERTYGROUPS';
export const FETCH_PROPERTYGROUPS_ACCUMULATED = 'FETCH_PROPERTYGROUPS_ACCUMULATED';
export const FETCH_PROPERTYGROUPS_FAILURE = 'FETCH_PROPERTYGROUPS_FAILURE';
export const FETCH_PROPERTYGROUPS_SUCCESS = 'FETCH_PROPERTYGROUPS_SUCCESS';

export const FETCH_PROPERTYGROUPS_LOCALISATION = 'FETCH_PROPERTYGROUPS_LOCALISATION';
export const FETCH_PROPERTYGROUPS_LOCALISATION_FAILURE = 'FETCH_PROPERTYGROUPS_LOCALISATION_FAILURE';
export const FETCH_PROPERTYGROUPS_LOCALISATION_SUCCESS = 'FETCH_PROPERTYGROUPS_LOCALISATION_SUCCESS';

export const PROPERTYGROUPS_LIST_PAGE = 'PROPERTYGROUPS_LIST_PAGE';
export const PROPERTYGROUPS_LIST_SORT = 'PROPERTYGROUPS_LIST_SORT';

// Property groups
export const FETCH_PROPERTYGROUP = 'FETCH_PROPERTYGROUP';
export const FETCH_PROPERTYGROUP_ACCUMULATED = 'FETCH_PROPERTYGROUP_ACCUMULATED';
export const FETCH_PROPERTYGROUP_FAILURE = 'FETCH_PROPERTYGROUP_FAILURE';
export const FETCH_PROPERTYGROUP_SUCCESS = 'FETCH_PROPERTYGROUP_SUCCESS';

export const FETCH_PROPERTYGROUP_LOCALISATION = 'FETCH_PROPERTYGROUP_LOCALISATION';
export const FETCH_PROPERTYGROUP_LOCALISATION_FAILURE = 'FETCH_PROPERTYGROUP_LOCALISATION_FAILURE';
export const FETCH_PROPERTYGROUP_LOCALISATION_SUCCESS = 'FETCH_PROPERTYGROUP_LOCALISATION_SUCCESS';

export const CREATE_PROPERTYGROUP = 'CREATE_PROPERTYGROUP';
export const CREATE_PROPERTYGROUP_FAILURE = 'CREATE_PROPERTYGROUP_FAILURE';

export const CREATE_PROPERTYGROUP_LOCALISATION = 'CREATE_PROPERTYGROUP_LOCALISATION';
export const CREATE_PROPERTYGROUP_LOCALISATION_FAILURE = 'CREATE_PROPERTYGROUP_LOCALISATION_FAILURE';
export const CREATE_PROPERTYGROUP_LOCALISATION_SUCCESS = 'CREATE_PROPERTYGROUP_LOCALISATION_SUCCESS';

export const UPDATE_PROPERTYGROUP = 'UPDATE_PROPERTYGROUP';
export const UPDATE_PROPERTYGROUP_FAILURE = 'UPDATE_PROPERTYGROUP_FAILURE';
export const UPDATE_PROPERTYGROUP_SUCCESS = 'UPDATE_PROPERTYGROUP_SUCCESS';

export const UPDATE_PROPERTYGROUP_LOCALISATION = 'UPDATE_PROPERTYGROUP_LOCALISATION';
export const UPDATE_PROPERTYGROUP_LOCALISATION_FAILURE = 'UPDATE_PROPERTYGROUP_LOCALISATION_FAILURE';
export const UPDATE_PROPERTYGROUP_LOCALISATION_SUCCESS = 'UPDATE_PROPERTYGROUP_LOCALISATION_SUCCESS';

export const DELETE_PROPERTYGROUP = 'DELETE_PROPERTYGROUP';
export const DELETE_PROPERTYGROUP_FAILURE = 'DELETE_PROPERTYGROUP_FAILURE';
export const DELETE_PROPERTYGROUP_SUCCESS = 'DELETE_PROPERTYGROUP_SUCCESS';

// Properties
export const FETCH_PROPERTIES = 'FETCH_PROPERTIES';
export const FETCH_PROPERTIES_FAILURE = 'FETCH_PROPERTIES_FAILURE';
export const FETCH_PROPERTIES_SUCCESS = 'FETCH_PROPERTIES_SUCCESS';

export const PROPERTIES_LIST_FILTER_UPDATE = 'PROPERTIES_LIST_FILTER_UPDATE';
export const PROPERTIES_LIST_CATEGORY = 'PROPERTIES_LIST_CATEGORY';
export const PROPERTIES_LIST_PAGE = 'PROPERTIES_LIST_PAGE';
export const PROPERTIES_LIST_SORT = 'PROPERTIES_LIST_SORT';

export const FETCH_PROPERTY = 'FETCH_PROPERTY';
export const FETCH_PROPERTY_FAILURE = 'FETCH_PROPERTY_FAILURE';
export const FETCH_PROPERTY_SUCCESS = 'FETCH_PROPERTY_SUCCESS';

export const FETCH_PROPERTY_LOCALISATION = 'FETCH_PROPERTY_LOCALISATION';
export const FETCH_PROPERTY_LOCALISATION_FAILURE = 'FETCH_PROPERTY_LOCALISATION_FAILURE';
export const FETCH_PROPERTY_LOCALISATION_SUCCESS = 'FETCH_PROPERTY_LOCALISATION_SUCCESS';

export const CREATE_PROPERTY = 'CREATE_PROPERTY';
export const CREATE_PROPERTY_FAILURE = 'CREATE_PROPERTY_FAILURE';

export const CREATE_PROPERTY_LOCALISATION = 'CREATE_PROPERTY_LOCALISATION';
export const CREATE_PROPERTY_LOCALISATION_FAILURE = 'CREATE_PROPERTY_LOCALISATION_FAILURE';
export const CREATE_PROPERTY_LOCALISATION_SUCCESS = 'CREATE_PROPERTY_LOCALISATION_SUCCESS';

export const UPDATE_PROPERTY = 'UPDATE_PROPERTY';
export const UPDATE_PROPERTY_FAILURE = 'UPDATE_PROPERTY_FAILURE';
export const UPDATE_PROPERTY_SUCCESS = 'UPDATE_PROPERTY_SUCCESS';

export const UPDATE_PROPERTY_LOCALISATION = 'UPDATE_PROPERTY_LOCALISATION';
export const UPDATE_PROPERTY_LOCALISATION_FAILURE = 'UPDATE_PROPERTY_LOCALISATION_FAILURE';
export const UPDATE_PROPERTY_LOCALISATION_SUCCESS = 'UPDATE_PROPERTY_LOCALISATION_SUCCESS';

export const DELETE_PROPERTY = 'DELETE_PROPERTY';
export const DELETE_PROPERTY_FAILURE = 'DELETE_PROPERTY_FAILURE';
export const DELETE_PROPERTY_SUCCESS = 'DELETE_PROPERTY_SUCCESS';

// Product Properties
export const FETCH_PRODUCT_PROPERTIES = 'FETCH_PRODUCT_PROPERTIES';
export const FETCH_PRODUCT_PROPERTIES_FAILURE = 'FETCH_PRODUCT_PROPERTIES_FAILURE';
export const FETCH_PRODUCT_PROPERTIES_SUCCESS = 'FETCH_PRODUCT_PROPERTIES_SUCCESS';

export const FETCH_PRODUCT_PROPERTY = 'FETCH_PRODUCT_PROPERTY';
export const FETCH_PRODUCT_PROPERTY_FAILURE = 'FETCH_PRODUCT_PROPERTY_FAILURE';
export const FETCH_PRODUCT_PROPERTY_SUCCESS = 'FETCH_PRODUCT_PROPERTY_SUCCESS';

export const CREATE_PRODUCT_PROPERTY = 'CREATE_PRODUCT_PROPERTY';
export const CREATE_PRODUCT_PROPERTY_FAILURE = 'CREATE_PRODUCT_PROPERTY_FAILURE';
export const CREATE_PRODUCT_PROPERTY_SUCCESS = 'CREATE_PRODUCT_PROPERTY_SUCCESS';

export const UPDATE_PRODUCT_PROPERTY = 'UPDATE_PRODUCT_PROPERTY';
export const UPDATE_PRODUCT_PROPERTY_FAILURE = 'UPDATE_PRODUCT_PROPERTY_FAILURE';
export const UPDATE_PRODUCT_PROPERTY_SUCCESS = 'UPDATE_PRODUCT_PROPERTY_SUCCESS';

export const DELETE_PRODUCT_PROPERTY = 'DELETE_PRODUCT_PROPERTY';
export const DELETE_PRODUCT_PROPERTY_FAILURE = 'DELETE_PRODUCT_PROPERTY_FAILURE';
export const DELETE_PRODUCT_PROPERTY_SUCCESS = 'DELETE_PRODUCT_PROPERTY_SUCCESS';

export const CREATE_WEBHOOK = 'CREATE_WEBHOOK';
export const CREATE_WEBHOOK_FAILURE = 'CREATE_WEBHOOK_FAILURE';
export const CREATE_WEBHOOK_SUCCESS = 'CREATE_WEBHOOK_SUCCESS';

export const DELETE_WEBHOOK = 'DELETE_WEBHOOK';
export const DELETE_WEBHOOK_FAILURE = 'DELETE_WEBHOOK_FAILURE';
export const DELETE_WEBHOOK_SUCCESS = 'DELETE_WEBHOOK_SUCCESS';

export const FETCH_WEBHOOKS = 'FETCH_WEBHOOKS';
export const FETCH_WEBHOOKS_FAILURE = 'FETCH_WEBHOOKS_FAILURE';
export const FETCH_WEBHOOKS_SUCCESS = 'FETCH_WEBHOOKS_SUCCESS';

export const WEBHOOK_LIST_FILTER_UPDATE = 'WEBHOOK_LIST_FILTER_UPDATE';
export const WEBHOOK_LIST_PAGE = 'WEBHOOK_LIST_PAGE';
export const WEBHOOK_LIST_SORT = 'WEBHOOK_LIST_SORT';

export const FETCH_WEBHOOK = 'FETCH_WEBHOOK';
export const FETCH_WEBHOOK_FAILURE = 'FETCH_WEBHOOK_FAILURE';
export const FETCH_WEBHOOK_SUCCESS = 'FETCH_WEBHOOK_SUCCESS';

export const UPDATE_WEBHOOK = 'UPDATE_WEBHOOK';
export const UPDATE_WEBHOOK_FAILURE = 'UPDATE_WEBHOOK_FAILURE';
export const UPDATE_WEBHOOK_SUCCESS = 'UPDATE_WEBHOOK_SUCCESS';

export const LOADER_OFF = 'LOADER_OFF';
export const LOADER_ON = 'LOADER_ON';

// Products
export const CREATE_PRODUCT = 'CREATE_PRODUCT';
export const CREATE_PRODUCT_FAILURE = 'CREATE_PRODUCT_FAILURE';
export const CREATE_PRODUCT_SUCCESS = 'CREATE_PRODUCT_SUCCESS';

export const CREATE_PRODUCT_LOGO = 'CREATE_PRODUCT_LOGO';
export const CREATE_PRODUCT_LOGO_FAILURE = 'CREATE_PRODUCT_LOGO_FAILURE';
export const CREATE_PRODUCT_LOGO_SUCCESS = 'CREATE_PRODUCT_LOGO_SUCCESS';

export const FETCH_PRODUCTS = 'FETCH_PRODUCTS';
export const FETCH_PRODUCTS_ACCUMULATED = 'FETCH_PRODUCTS_ACCUMULATED';
export const FETCH_PRODUCTS_FAILURE = 'FETCH_PRODUCTS_FAILURE';
export const FETCH_PRODUCTS_SUCCESS = 'FETCH_PRODUCTS_SUCCESS';

export const FETCH_PRODUCT = 'FETCH_PRODUCT';
export const FETCH_PRODUCT_ACCUMULATED = 'FETCH_PRODUCT_ACCUMULATED';
export const FETCH_PRODUCT_FAILURE = 'FETCH_PRODUCT_FAILURE';
export const FETCH_PRODUCT_SUCCESS = 'FETCH_PRODUCT_SUCCESS';

export const PRODUCTS_LIST_FILTER_UPDATE = 'PRODUCTS_LIST_FILTER_UPDATE';
export const PRODUCTS_LIST_FILTER_CATEGORY = 'PRODUCTS_LIST_FILTER_CATEGORY';
export const PRODUCTS_LIST_PAGE = 'PRODUCTS_LIST_PAGE';
export const PRODUCTS_LIST_SORT = 'PRODUCTS_LIST_SORT';

export const UPDATE_PRODUCT = 'UPDATE_PRODUCT';
export const UPDATE_PRODUCT_FAILURE = 'UPDATE_PRODUCT_FAILURE';
export const UPDATE_PRODUCT_SUCCESS = 'UPDATE_PRODUCT_SUCCESS';

export const DELETE_PRODUCT = 'DELETE_PRODUCT';
export const DELETE_PRODUCT_FAILURE = 'DELETE_PRODUCT_FAILURE';
export const DELETE_PRODUCT_SUCCESS = 'DELETE_PRODUCT_SUCCESS';

export const DELETE_PRODUCT_LOGO = 'DELETE_PRODUCT_LOGO';
export const DELETE_PRODUCT_LOGO_FAILURE = 'DELETE_PRODUCT_LOGO_FAILURE';
export const DELETE_PRODUCT_LOGO_SUCCESS = 'DELETE_PRODUCT_LOGO_SUCCESS';

// User Yields
export const ACCOUNT_YIELD_LIST_FILTER_UPDATE = 'ACCOUNT_YIELD_LIST_FILTER_UPDATE';
export const ACCOUNT_YIELD_LIST_FILTER_CATEGORY = 'ACCOUNT_YIELD_LIST_FILTER_CATEGORY';
export const ACCOUNT_YIELD_LIST_PAGE = 'ACCOUNT_YIELD_LIST_PAGE';
export const ACCOUNT_YIELD_LIST_SORT = 'ACCOUNT_YIELD_LIST_SORT';

export const FETCH_ACCOUNT_YIELDS = 'FETCH_ACCOUNT_YIELDS';
export const FETCH_ACCOUNT_YIELDS_FAILURE = 'FETCH_ACCOUNT_YIELDS_FAILURE';
export const FETCH_ACCOUNT_YIELDS_SUCCESS = 'FETCH_ACCOUNT_YIELDS_SUCCESS';

export const FETCH_ACCOUNT_YIELD = 'FETCH_ACCOUNT_YIELD';
export const FETCH_ACCOUNT_YIELD_FAILURE = 'FETCH_ACCOUNT_YIELD_FAILURE';
export const FETCH_ACCOUNT_YIELD_SUCCESS = 'FETCH_ACCOUNT_YIELD_SUCCESS';

export const CREATE_ACCOUNT_YIELD = 'CREATE_ACCOUNT_YIELD';
export const CREATE_ACCOUNT_YIELD_FAILURE = 'CREATE_ACCOUNT_YIELD_FAILURE';
export const CREATE_ACCOUNT_YIELD_SUCCESS = 'CREATE_ACCOUNT_YIELD_SUCCESS';

export const UPDATE_ACCOUNT_YIELD = 'UPDATE_ACCOUNT_YIELD';
export const UPDATE_ACCOUNT_YIELD_FAILURE = 'UPDATE_ACCOUNT_YIELD_FAILURE';
export const UPDATE_ACCOUNT_YIELD_SUCCESS = 'UPDATE_ACCOUNT_YIELD_SUCCESS';

export const DELETE_ACCOUNT_YIELD = 'DELETE_ACCOUNT_YIELD';
export const DELETE_ACCOUNT_YIELD_FAILURE = 'DELETE_ACCOUNT_YIELD_FAILURE';
export const DELETE_ACCOUNT_YIELD_SUCCESS = 'DELETE_ACCOUNT_YIELD_SUCCESS';

// Accounts
export const CREATE_ACCOUNT = 'CREATE_ACCOUNT';
export const CREATE_ACCOUNT_FAILURE = 'CREATE_ACCOUNT_FAILURE';
export const CREATE_ACCOUNT_SUCCESS = 'CREATE_ACCOUNT_SUCCESS';

export const DELETE_ACCOUNT = 'DELETE_ACCOUNT';
export const DELETE_ACCOUNT_FAILURE = 'DELETE_ACCOUNT_FAILURE';
export const DELETE_ACCOUNT_SUCCESS = 'DELETE_ACCOUNT_SUCCESS';

export const FETCH_ACCOUNTS = 'FETCH_ACCOUNTS';
export const FETCH_ACCOUNTS_ACCUMULATED = 'FETCH_ACCOUNTS_ACCUMULATED';
export const FETCH_ACCOUNTS_FAILURE = 'FETCH_ACCOUNTS_FAILURE';
export const FETCH_ACCOUNTS_SUCCESS = 'FETCH_ACCOUNTS_SUCCESS';

export const ACCOUNTS_LIST_FILTER_UPDATE = 'ACCOUNTS_LIST_FILTER_UPDATE';
export const ACCOUNTS_LIST_FILTER_CATEGORY = 'ACCOUNTS_LIST_FILTER_CATEGORY';
export const ACCOUNTS_LIST_PAGE = 'ACCOUNTS_LIST_PAGE';
export const ACCOUNTS_LIST_SORT = 'ACCOUNTS_LIST_SORT';

export const FETCH_ACCOUNT = 'FETCH_ACCOUNT';
export const FETCH_ACCOUNT_ACCUMULATED = 'FETCH_ACCOUNT_ACCUMULATED';
export const FETCH_ACCOUNT_FAILURE = 'FETCH_ACCOUNT_FAILURE';
export const FETCH_ACCOUNT_SUCCESS = 'FETCH_ACCOUNT_SUCCESS';

export const FETCH_CURRENT_ACCOUNT = 'FETCH_CURRENT_ACCOUNT';
export const FETCH_CURRENT_ACCOUNT_FAILURE = 'FETCH_CURRENT_ACCOUNT_FAILURE';
export const FETCH_CURRENT_ACCOUNT_SUCCESS = 'FETCH_CURRENT_ACCOUNT_SUCCESS';

export const UPDATE_ACCOUNT = 'UPDATE_ACCOUNT';
export const UPDATE_ACCOUNT_FAILURE = 'UPDATE_ACCOUNT_FAILURE';
export const UPDATE_ACCOUNT_SUCCESS = 'UPDATE_ACCOUNT_SUCCESS';

export const UPDATE_CURRENT_ACCOUNT = 'UPDATE_CURRENT_ACCOUNT';
export const UPDATE_CURRENT_ACCOUNT_FAILURE = 'UPDATE_CURRENT_ACCOUNT_FAILURE';
export const UPDATE_CURRENT_ACCOUNT_SUCCESS = 'UPDATE_CURRENT_ACCOUNT_SUCCESS';

export const FETCH_ACCOUNT_USERS = 'FETCH_ACCOUNT_USERS';
export const FETCH_ACCOUNT_USERS_FAILURE = 'FETCH_ACCOUNT_USERS_FAILURE';
export const FETCH_ACCOUNT_USERS_SUCCESS = 'FETCH_ACCOUNT_USERS_SUCCESS';

export const DELETE_ACCOUNT_USERS = 'DELETE_ACCOUNT_USERS';
export const DELETE_ACCOUNT_USERS_FAILURE = 'DELETE_ACCOUNT_USERS_FAILURE';
export const DELETE_ACCOUNT_USERS_SUCCESS = 'DELETE_ACCOUNT_USERS_SUCCESS';

export const ACCOUNT_USERS_FILTER_CATEGORY = 'ACCOUNT_USERS_FILTER_CATEGORY';
export const ACCOUNT_USERS_PAGE = 'ACCOUNT_USERS_PAGE';
export const ACCOUNT_USERS_SORT = 'ACCOUNT_USERS_SORT';
export const ACCOUNT_USERS_LIST_FILTER_UPDATE = 'ACCOUNT_USERS_LIST_FILTER_UPDATE';

// Invitations
export const CREATE_INVITATION = 'CREATE_INVITATION';
export const CREATE_INVITATION_SUCCESS = 'CREATE_INVITATION_SUCCESS';
export const CREATE_INVITATION_FAILURE = 'CREATE_INVITATION_FAILURE';

export const DELETE_INVITATION = 'DELETE_INVITATION';
export const DELETE_INVITATION_SUCCESS = 'DELETE_INVITATION_SUCCESS';
export const DELETE_INVITATION_FAILURE = 'DELETE_INVITATION_FAILURE';

export const FETCH_INVITATIONS = 'FETCH_INVITATIONS';
export const FETCH_INVITATIONS_SUCCESS = 'FETCH_INVITATIONS_SUCCESS';
export const FETCH_INVITATIONS_FAILURE = 'FETCH_INVITATIONS_FAILURE';

// Users
export const CREATE_USER = 'CREATE_USER';
export const CREATE_USER_FAILURE = 'CREATE_USER_FAILURE';
export const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS';

export const DELETE_USER = 'DELETE_USER';
export const DELETE_USER_FAILURE = 'DELETE_USER_FAILURE';
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';

export const FETCH_USERS = 'FETCH_USERS';
export const FETCH_USERS_ACCUMULATED = 'FETCH_USERS_ACCUMULATED';
export const FETCH_USERS_FAILURE = 'FETCH_USERS_FAILURE';
export const FETCH_USERS_SUCCESS = 'FETCH_USERS_SUCCESS';

export const USERS_LIST_FILTER_UPDATE = 'USERS_LIST_FILTER_UPDATE';
export const USERS_LIST_FILTER_CATEGORY = 'USERS_LIST_FILTER_CATEGORY';
export const USERS_LIST_PAGE = 'USERS_LIST_PAGE';
export const USERS_LIST_SORT = 'USERS_LIST_SORT';

export const FETCH_USER = 'FETCH_USER';
export const FETCH_USER_ACCUMULATED = 'FETCH_USER_ACCUMULATED';
export const FETCH_USER_FAILURE = 'FETCH_USER_FAILURE';
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS';

// User-memberships
export const DELETE_USER_MEMBERSHIP = 'DELETE_USER_MEMBERSHIP';
export const DELETE_USER_MEMBERSHIP_FAILURE = 'DELETE_USER_MEMBERSHIP_FAILURE';
export const DELETE_USER_MEMBERSHIP_SUCCESS = 'DELETE_USER_MEMBERSHIP_SUCCESS';

export const FETCH_PROVIDER_ACCUMULATED = 'FETCH_PROVIDER_ACCUMULATED';
export const FETCH_PROVIDERS_ACCUMULATED = 'FETCH_PROVIDERS_ACCUMULATED';

export const UPDATE_USER = 'UPDATE_USER';
export const UPDATE_USER_FAILURE = 'UPDATE_USER_FAILURE';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';

export const FETCH_PROFILE = 'FETCH_PROFILE';
export const FETCH_PROFILE_FAILURE = 'FETCH_PROFILE_FAILURE';
export const FETCH_PROFILE_SUCCESS = 'FETCH_PROFILE_SUCCESS';

export const UPDATE_PROFILE = 'UPDATE_PROFILE';
export const UPDATE_PROFILE_FAILURE = 'UPDATE_PROFILE_FAILURE';
export const UPDATE_PROFILE_SUCCESS = 'UPDATE_PROFILE_SUCCESS';

export const UPDATE_PROFILE_PASSWORD = 'UPDATE_PROFILE_PASSWORD';
export const UPDATE_PROFILE_PASSWORD_FAILURE = 'UPDATE_PROFILE_PASSWORD_FAILURE';
export const UPDATE_PROFILE_PASSWORD_SUCCESS = 'UPDATE_PROFILE_PASSWORD_SUCCESS';

export const UPDATE_USER_ACTIVITY_FAILURE = 'UPDATE_USER_ACTIVITY_FAILURE';
export const UPDATE_USER_ACTIVITY_SUCCESS = 'UPDATE_USER_ACTIVITY_SUCCESS';

export const UPDATE_USER_CONFIRMATION_FAILURE = 'UPDATE_USER_CONFIRMATION_FAILURE';
export const UPDATE_USER_CONFIRMATION_SUCCESS = 'UPDATE_USER_CONFIRMATION_SUCCESS';

export const RESET_USER_PASSWORD = 'RESET_USER_PASSWORD';
export const RESET_USER_PASSWORD_FAILURE = 'RESET_USER_PASSWORD_FAILURE';
export const RESET_USER_PASSWORD_SUCCESS = 'RESET_USER_PASSWORD_SUCCESS';

// User-product-memberships
export const FETCH_USER_PRODUCT_MEMBERSHIPS = 'FETCH_USER_PRODUCT_MEMBERSHIPS';
export const FETCH_USER_PRODUCT_MEMBERSHIPS_FAILURE = 'FETCH_USER_PRODUCT_MEMBERSHIPS_FAILURE';
export const FETCH_USER_PRODUCT_MEMBERSHIPS_SUCCESS = 'FETCH_USER_PRODUCT_MEMBERSHIPS_SUCCESS';

export const FETCH_USER_PRODUCT_MEMBERSHIP = 'FETCH_USER_PRODUCT_MEMBERSHIP';
export const FETCH_USER_PRODUCT_MEMBERSHIP_FAILURE = 'FETCH_USER_PRODUCT_MEMBERSHIP_FAILURE';
export const FETCH_USER_PRODUCT_MEMBERSHIP_SUCCESS = 'FETCH_USER_PRODUCT_MEMBERSHIP_SUCCESS';

export const CREATE_USER_PRODUCT_MEMBERSHIP = 'CREATE_USER_PRODUCT_MEMBERSHIP';
export const CREATE_USER_PRODUCT_MEMBERSHIP_FAILURE = 'CREATE_USER_PRODUCT_MEMBERSHIP_FAILURE';
export const CREATE_USER_PRODUCT_MEMBERSHIP_SUCCESS = 'CREATE_USER_PRODUCT_MEMBERSHIP_SUCCESS';

export const DELETE_USER_PRODUCT_MEMBERSHIP = 'DELETE_USER_PRODUCT_MEMBERSHIP';
export const DELETE_USER_PRODUCT_MEMBERSHIP_FAILURE = 'DELETE_USER_PRODUCT_MEMBERSHIP_FAILURE';
export const DELETE_USER_PRODUCT_MEMBERSHIP_SUCCESS = 'DELETE_USER_PRODUCT_MEMBERSHIP_SUCCESS';

export const UPDATE_USER_PRODUCT_MEMBERSHIP = 'UPDATE_USER_PRODUCT_MEMBERSHIP';
export const UPDATE_USER_PRODUCT_MEMBERSHIP_FAILURE = 'UPDATE_USER_PRODUCT_MEMBERSHIP_FAILURE';
export const UPDATE_USER_PRODUCT_MEMBERSHIP_SUCCESS = 'UPDATE_USER_PRODUCT_MEMBERSHIP_SUCCESS';

export const FETCH_USER_PRODUCT_MEMBERSHIP_POOLS = 'FETCH_USER_PRODUCT_MEMBERSHIP_POOLS';
export const FETCH_USER_PRODUCT_MEMBERSHIP_POOLS_FAILURE = 'FETCH_USER_PRODUCT_MEMBERSHIP_POOLS_FAILURE';
export const FETCH_USER_PRODUCT_MEMBERSHIP_POOLS_SUCCESS = 'FETCH_USER_PRODUCT_MEMBERSHIP_POOLS_SUCCESS';

export const FETCH_USER_PRODUCT_MEMBERSHIP_POOL = 'FETCH_USER_PRODUCT_MEMBERSHIP_POOL';
export const FETCH_USER_PRODUCT_MEMBERSHIP_POOL_FAILURE = 'FETCH_USER_PRODUCT_MEMBERSHIP_POOL_FAILURE';
export const FETCH_USER_PRODUCT_MEMBERSHIP_POOL_SUCCESS = 'FETCH_USER_PRODUCT_MEMBERSHIP_POOL_SUCCESS';

export const CREATE_USER_PRODUCT_MEMBERSHIP_POOL = 'CREATE_USER_PRODUCT_MEMBERSHIP_POOL';
export const CREATE_USER_PRODUCT_MEMBERSHIP_POOL_FAILURE = 'CREATE_USER_PRODUCT_MEMBERSHIP_POOL_FAILURE';
export const CREATE_USER_PRODUCT_MEMBERSHIP_POOL_SUCCESS = 'CREATE_USER_PRODUCT_MEMBERSHIP_POOL_SUCCESS';

export const UPDATE_USER_PRODUCT_MEMBERSHIP_POOL = 'UPDATE_USER_PRODUCT_MEMBERSHIP_POOL';
export const UPDATE_USER_PRODUCT_MEMBERSHIP_POOL_FAILURE = 'UPDATE_USER_PRODUCT_MEMBERSHIP_POOL_FAILURE';
export const UPDATE_USER_PRODUCT_MEMBERSHIP_POOL_SUCCESS = 'UPDATE_USER_PRODUCT_MEMBERSHIP_POOL_SUCCESS';

export const DELETE_USER_PRODUCT_MEMBERSHIP_POOL = 'DELETE_USER_PRODUCT_MEMBERSHIP_POOL';
export const DELETE_USER_PRODUCT_MEMBERSHIP_POOL_FAILURE = 'DELETE_USER_PRODUCT_MEMBERSHIP_POOL_FAILURE';
export const DELETE_USER_PRODUCT_MEMBERSHIP_POOL_SUCCESS = 'DELETE_USER_PRODUCT_MEMBERSHIP_POOL_SUCCESS';

export const CREATE_TRANSLATION_FAILURE = 'CREATE_TRANSLATION_FAILURE';
export const CREATE_TRANSLATION_SUCCESS = 'CREATE_TRANSLATION_SUCCESS';

export const MODAL_CLOSE = 'MODAL_CLOSE';
export const MODAL_LOADING_START = 'MODAL_LOADING_START';
export const MODAL_LOADING_STOP = 'MODAL_LOADING_STOP';
export const MODAL_OPEN = 'MODAL_OPEN';

export const TOGGLE_SIDEBAR = '[UI] Sidebar - Toggle';

export const HIDE_NOTIFICATION = '[UI] Notification - Hide';
export const SHOW_NOTIFICATION = '[UI] Notification - Show';

export const FETCH_RESERVATIONS = '[Reservations] - Fetch';
export const FETCH_RESERVATIONS_FAILURE = '[Reservations] - Fetch Failure';
export const FETCH_RESERVATIONS_SUCCESS = '[Reservations] - Fetch Success';

export const FETCH_RESERVATION = '[Reservation] - Fetch';
export const FETCH_RESERVATION_FAILURE = '[Reservation] - Fetch Failure';
export const FETCH_RESERVATION_SUCCESS = '[Reservation] - Fetch Success';

export const RESERVATIONS_LIST_FILTER_UPDATE = 'RESERVATIONS_LIST_FILTER_UPDATE';
export const RESERVATIONS_LIST_FILTER_CATEGORY = 'RESERVATIONS_LIST_FILTER_CATEGORY';
export const RESERVATIONS_LIST_PAGE = 'RESERVATIONS_LIST_PAGE';
export const RESERVATIONS_LIST_SORT = 'RESERVATIONS_LIST_SORT';

export const RESERVATION_EXPORT = 'RESERVATION_EXPORT';
export const RESERVATION_EXPORT_FAILURE = 'RESERVATION_EXPORT_FAILURE';
export const RESERVATION_EXPORT_SUCCESS = 'RESERVATION_EXPORT_SUCCESS';

export const RESERVATION_SESSION_START = 'RESERVATION_SESSION_START';
export const RESERVATION_SESSION_STOP = 'RESERVATION_SESSION_STOP';
export const RESERVATION_SESSION_OPEN_BARRIER = 'RESERVATION_SESSION_OPEN_BARRIER';

export const CANCEL_BOOKING = 'CANCEL_BOOKING';
export const CANCEL_BOOKING_FAILURE = 'CANCEL_BOOKING_FAILURE';
export const CANCEL_BOOKING_SUCCESS = 'CANCEL_BOOKING_SUCCESS';

export const BOOKING_STATS_LIST_FILTER_UPDATE = 'BOOKING_STATS_LIST_FILTER_UPDATE';
export const BOOKING_STATS_LIST_FILTER_CATEGORY = 'BOOKING_STATS_LIST_FILTER_CATEGORY';
export const BOOKING_STATS_LIST_PAGE = 'BOOKING_STATS_LIST_PAGE';
export const BOOKING_STATS_LIST_SORT = 'BOOKING_STATS_LIST_SORT';

export const FETCH_BOOKING_STATS = 'FETCH_BOOKING_STATS';
export const FETCH_BOOKING_STATS_FAILURE = 'FETCH_BOOKING_STATS_FAILURE';
export const FETCH_BOOKING_STATS_SUCCESS = 'FETCH_BOOKING_STATS_SUCCESS';

export const FETCH_BOOKINGS = 'FETCH_BOOKINGS';
export const FETCH_BOOKINGS_ACCUMULATED = 'FETCH_BOOKINGS_ACCUMULATED';
export const FETCH_BOOKINGS_FAILURE = 'FETCH_BOOKINGS_FAILURE';
export const FETCH_BOOKINGS_SUCCESS = 'FETCH_BOOKINGS_SUCCESS';

export const FETCH_BOOKING = 'FETCH_BOOKING';
export const FETCH_BOOKING_ACCUMULATED = 'FETCH_BOOKING_ACCUMULATED';
export const FETCH_BOOKING_FAILURE = 'FETCH_BOOKING_FAILURE';
export const FETCH_BOOKING_SUCCESS = 'FETCH_BOOKING_SUCCESS';

export const UPDATE_BOOKING = 'UPDATE_BOOKING';
export const UPDATE_BOOKING_FAILURE = 'UPDATE_BOOKING_FAILURE';
export const UPDATE_BOOKING_SUCCESS = 'UPDATE_BOOKING_SUCCESS';

export const BOOKING_EXPORT = 'BOOKING_EXPORT';
export const BOOKING_EXPORT_FAILURE = 'BOOKING_EXPORT_FAILURE';
export const BOOKING_EXPORT_SUCCESS = 'BOOKING_EXPORT_SUCCESS';

export const FULL_BOOKING_EXPORT = 'FULL_BOOKING_EXPORT';
export const FULL_BOOKING_EXPORT_FAILURE = 'FULL_BOOKING_EXPORT_FAILURE';
export const FULL_BOOKING_EXPORT_SUCCESS = 'FULL_BOOKING_EXPORT_SUCCESS';

export const BOOKINGS_LIST_FILTER = 'BOOKINGS_LIST_FILTER';
export const BOOKINGS_LIST_FILTER_UPDATE = 'BOOKINGS_LIST_FILTER_UPDATE';
export const BOOKINGS_LIST_FILTER_CATEGORY = 'BOOKINGS_LIST_FILTER_CATEGORY';
export const BOOKINGS_LIST_PAGE = 'BOOKINGS_LIST_PAGE';
export const BOOKINGS_LIST_SORT = 'BOOKINGS_LIST_SORT';

export const FETCH_RESERVATION_ACCESS_SESSION_ACTIVITIES = 'FETCH_RESERVATION_ACCESS_SESSION_ACTIVITIES';
export const FETCH_RESERVATION_ACCESS_SESSION_ACTIVITIES_SUCCESS = 'FETCH_RESERVATION_ACCESS_SESSION_ACTIVITIES_SUCCESS';
export const FETCH_RESERVATION_ACCESS_SESSION_ACTIVITIES_FAILURE = 'FETCH_RESERVATION_ACCESS_SESSION_ACTIVITIES_FAILURE';

export const FETCH_DISCOUNT = 'FETCH_DISCOUNT';
export const FETCH_DISCOUNT_FAILURE = 'FETCH_DISCOUNT_FAILURE';
export const FETCH_DISCOUNT_SUCCESS = 'FETCH_DISCOUNT_SUCCESS';

export const FETCH_DISCOUNTS = 'FETCH_DISCOUNTS';
export const FETCH_DISCOUNTS_FAILURE = 'FETCH_DISCOUNTS_FAILURE';
export const FETCH_DISCOUNTS_SUCCESS = 'FETCH_DISCOUNTS_SUCCESS';

export const CREATE_DISCOUNT = 'CREATE_DISCOUNT';
export const CREATE_DISCOUNT_FAILURE = 'CREATE_DISCOUNT_FAILURE';
export const CREATE_DISCOUNT_SUCCESS = 'CREATE_DISCOUNT_SUCCESS';

export const DELETE_DISCOUNT = 'DELETE_DISCOUNT';
export const DELETE_DISCOUNT_FAILURE = 'DELETE_DISCOUNT_FAILURE';
export const DELETE_DISCOUNT_SUCCESS = 'DELETE_DISCOUNT_SUCCESS';

export const UPDATE_DISCOUNT = 'UPDATE_DISCOUNT';
export const UPDATE_DISCOUNT_FAILURE = 'UPDATE_DISCOUNT_FAILURE';
export const UPDATE_DISCOUNT_SUCCESS = 'UPDATE_DISCOUNT_SUCCESS';

export const FETCH_DISCOUNT_CODES = 'FETCH_DISCOUNT_CODES';
export const FETCH_DISCOUNT_CODES_FAILURE = 'FETCH_DISCOUNT_CODES_FAILURE';
export const FETCH_DISCOUNT_CODES_SUCCESS = 'FETCH_DISCOUNT_CODES_SUCCESS';

export const FETCH_DISCOUNT_CODE = 'FETCH_DISCOUNT_CODE';
export const FETCH_DISCOUNT_CODE_FAILURE = 'FETCH_DISCOUNT_CODE_FAILURE';
export const FETCH_DISCOUNT_CODE_SUCCESS = 'FETCH_DISCOUNT_CODE_SUCCESS';

export const CREATE_DISCOUNT_CODE = 'CREATE_DISCOUNT_CODE';
export const CREATE_DISCOUNT_CODE_FAILURE = 'CREATE_DISCOUNT_CODE_FAILURE';
export const CREATE_DISCOUNT_CODE_SUCCESS = 'CREATE_DISCOUNT_CODE_SUCCESS';

export const DELETE_DISCOUNT_CODE = 'DELETE_DISCOUNT_CODE';
export const DELETE_DISCOUNT_CODE_FAILURE = 'DELETE_DISCOUNT_CODE_FAILURE';
export const DELETE_DISCOUNT_CODE_SUCCESS = 'DELETE_DISCOUNT_CODE_SUCCESS';

export const UPDATE_DISCOUNT_CODE = 'UPDATE_DISCOUNT_CODE';
export const UPDATE_DISCOUNT_CODE_FAILURE = 'UPDATE_DISCOUNT_CODE_FAILURE';
export const UPDATE_DISCOUNT_CODE_SUCCESS = 'UPDATE_DISCOUNT_CODE_SUCCESS';

export const EXPORT_DISCOUNT_CODES = 'EXPORT_DISCOUNT_CODES';
export const EXPORT_DISCOUNT_CODES_FAILURE = 'EXPORT_DISCOUNT_CODES_FAILURE';
export const EXPORT_DISCOUNT_CODES_SUCCESS = 'EXPORT_DISCOUNT_CODES_SUCCESS';

export const DISCOUNTS_LIST_FILTER_UPDATE = 'DISCOUNTS_LIST_FILTER_UPDATE';
export const DISCOUNTS_LIST_FILTER_CATEGORY = 'DISCOUNTS_LIST_FILTER_CATEGORY';
export const DISCOUNTS_LIST_PAGE = 'DISCOUNTS_LIST_PAGE';
export const DISCOUNTS_LIST_SORT = 'DISCOUNTS_LIST_SORT';

export const DISCOUNT_CODES_LIST_FILTER_UPDATE = 'DISCOUNT_CODES_LIST_FILTER_UPDATE';
export const DISCOUNT_CODES_LIST_FILTER_CATEGORY = 'DISCOUNT_CODES_LIST_FILTER_CATEGORY';
export const DISCOUNT_CODES_LIST_PAGE = 'DISCOUNT_CODES_LIST_PAGE';
export const DISCOUNT_CODES_LIST_SORT = 'DISCOUNT_CODES_LIST_SORT';

// Subscriptions
export const FETCH_SUBSCRIPTION = 'FETCH_SUBSCRIPTION';
export const FETCH_SUBSCRIPTION_SUCCESS = 'FETCH_SUBSCRIPTION_SUCCESS';
export const FETCH_SUBSCRIPTION_FAILURE = 'FETCH_SUBSCRIPTION_FAILURE';

export const FETCH_SUBSCRIPTIONS = 'FETCH_SUBSCRIPTIONS';
export const FETCH_SUBSCRIPTIONS_SUCCESS = 'FETCH_SUBSCRIPTIONS_SUCCESS';
export const FETCH_SUBSCRIPTIONS_FAILURE = 'FETCH_SUBSCRIPTIONS_FAILURE';

export const DELETE_SUBSCRIPTION = 'DELETE_SUBSCRIPTION';
export const DELETE_SUBSCRIPTION_SUCCESS = 'DELETE_SUBSCRIPTION_SUCCESS';
export const DELETE_SUBSCRIPTION_FAILURE = 'DELETE_SUBSCRIPTION_FAILURE';

export const CREATE_SUBSCRIPTION = 'CREATE_SUBSCRIPTION';
export const CREATE_SUBSCRIPTION_FAILURE = 'CREATE_SUBSCRIPTION_FAILURE';
export const CREATE_SUBSCRIPTION_SUCCESS = 'CREATE_SUBSCRIPTION_SUCCESS';

export const UPDATE_SUBSCRIPTION = 'UPDATE_SUBSCRIPTION';
export const UPDATE_SUBSCRIPTION_FAILURE = 'UPDATE_SUBSCRIPTION_FAILURE';
export const UPDATE_SUBSCRIPTION_SUCCESS = 'UPDATE_SUBSCRIPTION_SUCCESS';

export const SUBSCRIPTIONS_LIST_PAGE = 'SUBSCRIPTIONS_LIST_PAGE';
export const SUBSCRIPTIONS_LIST_FILTER_UPDATE = 'SUBSCRIPTIONS_LIST_FILTER_UPDATE';
export const SUBSCRIPTIONS_LIST_FILTER_CATEGORY = 'SUBSCRIPTIONS_LIST_FILTER_CATEGORY';
export const SUBSCRIPTIONS_LIST_SORT = 'SUBSCRIPTIONS_LIST_SORT';

export const CONFIRM_SUBSCRIPTION = 'CONFIRM_SUBSCRIPTION';
export const CONFIRM_SUBSCRIPTION_FAILURE = 'CONFIRM_SUBSCRIPTION_FAILURE';
export const CONFIRM_SUBSCRIPTION_SUCCESS = 'CONFIRM_SUBSCRIPTION_SUCCESS';

export const TERMINATE_SUBSCRIPTION = 'TERMINATE_SUBSCRIPTION';
export const TERMINATE_SUBSCRIPTION_FAILURE = 'TERMINATE_SUBSCRIPTION_FAILURE';
export const TERMINATE_SUBSCRIPTION_SUCCESS = 'TERMINATE_SUBSCRIPTION_SUCCESS';

// Memberships
export const FETCH_MEMBERSHIPS = 'FETCH_MEMBERSHIPS';
export const FETCH_MEMBERSHIPS_SUCCESS = 'FETCH_MEMBERSHIPS_SUCCESS';
export const FETCH_MEMBERSHIPS_FAILURE = 'FETCH_MEMBERSHIPS_FAILURE';

export const MEMBERSHIPS_LIST_PAGE = 'MEMBERSHIPS_LIST_PAGE';

export const FETCH_MEMBERSHIP = 'FETCH_MEMBERSHIP';
export const FETCH_MEMBERSHIP_SUCCESS = 'FETCH_MEMBERSHIP_SUCCESS';
export const FETCH_MEMBERSHIP_FAILURE = 'FETCH_MEMBERSHIP_FAILURE';

export const DELETE_MEMBERSHIP = 'DELETE_MEMBERSHIP';
export const DELETE_MEMBERSHIP_SUCCESS = 'DELETE_MEMBERSHIP_SUCCESS';
export const DELETE_MEMBERSHIP_FAILURE = 'DELETE_MEMBERSHIP_FAILURE';

export const CREATE_MEMBERSHIP = 'CREATE_MEMBERSHIP';
export const CREATE_MEMBERSHIP_FAILURE = 'CREATE_MEMBERSHIP_FAILURE';
export const CREATE_MEMBERSHIP_SUCCESS = 'CREATE_MEMBERSHIP_SUCCESS';

export const UPDATE_MEMBERSHIP = 'UPDATE_MEMBERSHIP';
export const UPDATE_MEMBERSHIP_FAILURE = 'UPDATE_MEMBERSHIP_FAILURE';
export const UPDATE_MEMBERSHIP_SUCCESS = 'UPDATE_MEMBERSHIP_SUCCESS';

export const MEMBERSHIPS_LIST_FILTER_CATEGORY = 'MEMBERSHIPS_LIST_FILTER_CATEGORY';
export const MEMBERSHIPS_LIST_FILTER_UPDATE = 'MEMBERSHIPS_LIST_FILTER_UPDATE';
export const MEMBERSHIPS_LIST_SORT = 'MEMBERSHIPS_LIST_SORT';

// Membership schedules
export const FETCH_MEMBERSHIP_SCHEDULES = 'FETCH_MEMBERSHIP_SCHEDULES';
export const FETCH_MEMBERSHIP_SCHEDULES_SUCCESS = 'FETCH_MEMBERSHIP_SCHEDULES_SUCCESS';
export const FETCH_MEMBERSHIP_SCHEDULES_FAILURE = 'FETCH_MEMBERSHIP_SCHEDULES_FAILURE';

export const FETCH_MEMBERSHIP_SCHEDULE = 'FETCH_MEMBERSHIP_SCHEDULE';
export const FETCH_MEMBERSHIP_SCHEDULE_SUCCESS = 'FETCH_MEMBERSHIP_SCHEDULE_SUCCESS';
export const FETCH_MEMBERSHIP_SCHEDULE_FAILURE = 'FETCH_MEMBERSHIP_SCHEDULE_FAILURE';

export const CREATE_MEMBERSHIP_SCHEDULE = 'CREATE_MEMBERSHIP_SCHEDULE';
export const CREATE_MEMBERSHIP_SCHEDULE_FAILURE = 'CREATE_MEMBERSHIP_SCHEDULE_FAILURE';
export const CREATE_MEMBERSHIP_SCHEDULE_SUCCESS = 'CREATE_MEMBERSHIP_SCHEDULE_SUCCESS';

export const UPDATE_MEMBERSHIP_SCHEDULE = 'UPDATE_MEMBERSHIP_SCHEDULE';
export const UPDATE_MEMBERSHIP_SCHEDULE_FAILURE = 'UPDATE_MEMBERSHIP_SCHEDULE_FAILURE';
export const UPDATE_MEMBERSHIP_SCHEDULE_SUCCESS = 'UPDATE_MEMBERSHIP_SCHEDULE_SUCCESS';

export const DELETE_MEMBERSHIP_SCHEDULE = 'DELETE_MEMBERSHIP_SCHEDULE';
export const DELETE_MEMBERSHIP_SCHEDULE_FAILURE = 'DELETE_MEMBERSHIP_SCHEDULE_FAILURE';
export const DELETE_MEMBERSHIP_SCHEDULE_SUCCESS = 'DELETE_MEMBERSHIP_SCHEDULE_SUCCESS';

// Access points
export const FETCH_ACCESS_POINTS = 'FETCH_ACCESS_POINTS';
export const FETCH_ACCESS_POINTS_SUCCESS = 'FETCH_ACCESS_POINTS_SUCCESS';
export const FETCH_ACCESS_POINTS_FAILURE = 'FETCH_ACCESS_POINTS_FAILURE';

export const FETCH_ACCESS_POINT = 'FETCH_ACCESS_POINT';
export const FETCH_ACCESS_POINT_SUCCESS = 'FETCH_ACCESS_POINT_SUCCESS';
export const FETCH_ACCESS_POINT_FAILURE = 'FETCH_ACCESS_POINT_FAILURE';

export const CREATE_ACCESS_POINT = 'CREATE_ACCESS_POINT';
export const CREATE_ACCESS_POINT_SUCCESS = 'CREATE_ACCESS_POINT_SUCCESS';
export const CREATE_ACCESS_POINT_FAILURE = 'CREATE_ACCESS_POINT_FAILURE';

export const UPDATE_ACCESS_POINT = 'UPDATE_ACCESS_POINT';
export const UPDATE_ACCESS_POINT_SUCCESS = 'UPDATE_ACCESS_POINT_SUCCESS';
export const UPDATE_ACCESS_POINT_FAILURE = 'UPDATE_ACCESS_POINT_FAILURE';

export const ACCESS_POINTS_LIST_PAGE = 'ACCESS_POINTS_LIST_PAGE';

export const ACCESS_POINTS_LIST_FILTER_CATEGORY = 'ACCESS_POINTS_LIST_FILTER_CATEGORY';
export const ACCESS_POINTS_LIST_FILTER_UPDATE = 'ACCESS_POINTS_LIST_FILTER_UPDATE';
export const ACCESS_POINTS_LIST_SORT = 'ACCESS_POINTS_LIST_SORT';

// Access points accessmethods
export const FETCH_ACCESS_POINTS_ACCESS_METHODS = 'FETCH_ACCESS_POINTS_ACCESS_METHODS';
export const FETCH_ACCESS_POINTS_ACCESS_METHODS_FAILURE = 'FETCH_ACCESS_POINTS_ACCESS_METHODS_FAILURE';
export const FETCH_ACCESS_POINTS_ACCESS_METHODS_SUCCESS = 'FETCH_ACCESS_POINTS_ACCESS_METHODS_SUCCESS';

export const CREATE_ACCESS_POINTS_ACCESS_METHOD = 'CREATE_ACCESS_POINTS_ACCESS_METHOD';
export const CREATE_ACCESS_POINTS_ACCESS_METHOD_FAILURE = 'CREATE_ACCESS_POINTS_ACCESS_METHOD_FAILURE';
export const CREATE_ACCESS_POINTS_ACCESS_METHOD_SUCCESS = 'CREATE_ACCESS_POINTS_ACCESS_METHOD_SUCCESS';

export const CREATE_ACCESS_POINTS_ACCESS_METHOD_OPEN = 'CREATE_ACCESS_POINTS_ACCESS_METHOD_OPEN';
export const CREATE_ACCESS_POINTS_ACCESS_METHOD_OPEN_FAILURE = 'CREATE_ACCESS_POINTS_ACCESS_METHOD_OPEN_FAILURE';
export const CREATE_ACCESS_POINTS_ACCESS_METHOD_OPEN_SUCCESS = 'CREATE_ACCESS_POINTS_ACCESS_METHOD_OPEN_SUCCESS';

export const UPDATE_ACCESS_POINTS_ACCESS_METHOD = 'UPDATE_ACCESS_POINTS_ACCESS_METHOD';
export const UPDATE_ACCESS_POINTS_ACCESS_METHOD_FAILURE = 'UPDATE_ACCESS_POINTS_ACCESS_METHOD_FAILURE';
export const UPDATE_ACCESS_POINTS_ACCESS_METHOD_SUCCESS = 'UPDATE_ACCESS_POINTS_ACCESS_METHOD_SUCCESS';

export const DELETE_ACCESS_POINTS_ACCESS_METHOD = 'DELETE_ACCESS_POINTS_ACCESS_METHOD';
export const DELETE_ACCESS_POINTS_ACCESS_METHOD_FAILURE = 'DELETE_ACCESS_POINTS_ACCESS_METHOD_FAILURE';
export const DELETE_ACCESS_POINTS_ACCESS_METHOD_SUCCESS = 'DELETE_ACCESS_POINTS_ACCESS_METHOD_SUCCESS';

// Invoices
export const FETCH_INVOICES = 'FETCH_INVOICES';
export const FETCH_INVOICES_FAILURE = 'FETCH_INVOICES_FAILURE';
export const FETCH_INVOICES_SUCCESS = 'FETCH_INVOICES_SUCCESS';

export const INVOICES_LIST_FILTER_CATEGORY = 'INVOICES_LIST_FILTER_CATEGORY';
export const INVOICES_LIST_FILTER_UPDATE = 'INVOICES_LIST_FILTER_UPDATE';
export const INVOICES_LIST_PAGE = 'INVOICES_LIST_PAGE';
export const INVOICES_LIST_SORT = 'INVOICES_LIST_SORT';

export const EXPORT_INVOICES = 'EXPORT_INVOICES';
export const EXPORT_INVOICES_FAILURE = 'EXPORT_INVOICES_FAILURE';
export const EXPORT_INVOICES_SUCCESS = 'EXPORT_INVOICES_SUCCESS';

export const DOWNLOAD_INVOICES_FAILURE = 'DOWNLOAD_INVOICES_FAILURE';

export const EXPORT_INVOICES_LINES = 'EXPORT_INVOICES_LINES';
export const EXPORT_INVOICES_LINES_FAILURE = 'EXPORT_INVOICES_LINES_FAILURE';
export const EXPORT_INVOICES_LINES_SUCCESS = 'EXPORT_INVOICES_LINES_SUCCESS';

// Product memberships
export const FETCH_PRODUCT_MEMBERSHIPS = 'FETCH_PRODUCT_MEMBERSHIPS';
export const FETCH_PRODUCT_MEMBERSHIPS_FAILURE = 'FETCH_PRODUCT_MEMBERSHIPS_FAILURE';
export const FETCH_PRODUCT_MEMBERSHIPS_SUCCESS = 'FETCH_PRODUCT_MEMBERSHIPS_SUCCESS';

export const FETCH_PRODUCT_MEMBERSHIP = 'FETCH_PRODUCT_MEMBERSHIP';
export const FETCH_PRODUCT_MEMBERSHIP_FAILURE = 'FETCH_PRODUCT_MEMBERSHIP_FAILURE';
export const FETCH_PRODUCT_MEMBERSHIP_SUCCESS = 'FETCH_PRODUCT_MEMBERSHIP_SUCCESS';

export const CREATE_PRODUCT_MEMBERSHIP = 'CREATE_PRODUCT_MEMBERSHIP';
export const CREATE_PRODUCT_MEMBERSHIP_FAILURE = 'CREATE_PRODUCT_MEMBERSHIP_FAILURE';
export const CREATE_PRODUCT_MEMBERSHIP_SUCCESS = 'CREATE_PRODUCT_MEMBERSHIP_SUCCESS';

export const UPDATE_PRODUCT_MEMBERSHIP = 'UPDATE_PRODUCT_MEMBERSHIP';
export const UPDATE_PRODUCT_MEMBERSHIP_FAILURE = 'UPDATE_PRODUCT_MEMBERSHIP_FAILURE';
export const UPDATE_PRODUCT_MEMBERSHIP_SUCCESS = 'UPDATE_PRODUCT_MEMBERSHIP_SUCCESS';

export const DELETE_PRODUCT_MEMBERSHIP = 'DELETE_PRODUCT_MEMBERSHIP';
export const DELETE_PRODUCT_MEMBERSHIP_FAILURE = 'DELETE_PRODUCT_MEMBERSHIP_FAILURE';
export const DELETE_PRODUCT_MEMBERSHIP_SUCCESS = 'DELETE_PRODUCT_MEMBERSHIP_SUCCESS';

export const PRODUCT_MEMBERSHIPS_LIST_PAGE = 'PRODUCT_MEMBERSHIPS_LIST_PAGE';
export const PRODUCT_MEMBERSHIPS_LIST_SORT = 'PRODUCT_MEMBERSHIPS_LIST_SORT';
export const PRODUCT_MEMBERSHIPS_LIST_FILTER_CATEGORY = 'PRODUCT_MEMBERSHIPS_LIST_FILTER_CATEGORY';
export const PRODUCT_MEMBERSHIPS_LIST_FILTER_UPDATE = 'PRODUCT_MEMBERSHIPS_LIST_FILTER_UPDATE';

// Membership pools
export const FETCH_MEMBERSHIP_POOLS = 'FETCH_MEMBERSHIP_POOLS';
export const FETCH_MEMBERSHIP_POOLS_FAILURE = 'FETCH_MEMBERSHIP_POOLS_FAILURE';
export const FETCH_MEMBERSHIP_POOLS_SUCCESS = 'FETCH_MEMBERSHIP_POOLS_SUCCESS';

export const FETCH_MEMBERSHIP_POOL = 'FETCH_MEMBERSHIP_POOL';
export const FETCH_MEMBERSHIP_POOL_FAILURE = 'FETCH_MEMBERSHIP_POOL_FAILURE';
export const FETCH_MEMBERSHIP_POOL_SUCCESS = 'FETCH_MEMBERSHIP_POOL_SUCCESS';

export const CREATE_MEMBERSHIP_POOL = 'CREATE_MEMBERSHIP_POOL';
export const CREATE_MEMBERSHIP_POOL_FAILURE = 'CREATE_MEMBERSHIP_POOL_FAILURE';
export const CREATE_MEMBERSHIP_POOL_SUCCESS = 'CREATE_MEMBERSHIP_POOL_SUCCESS';

export const UPDATE_MEMBERSHIP_POOL = 'UPDATE_MEMBERSHIP_POOL';
export const UPDATE_MEMBERSHIP_POOL_FAILURE = 'UPDATE_MEMBERSHIP_POOL_FAILURE';
export const UPDATE_MEMBERSHIP_POOL_SUCCESS = 'UPDATE_MEMBERSHIP_POOL_SUCCESS';

export const DELETE_MEMBERSHIP_POOL = 'DELETE_MEMBERSHIP_POOL';
export const DELETE_MEMBERSHIP_POOL_FAILURE = 'DELETE_MEMBERSHIP_POOL_FAILURE';
export const DELETE_MEMBERSHIP_POOL_SUCCESS = 'DELETE_MEMBERSHIP_POOL_SUCCESS';

export const MEMBERSHIP_POOLS_LIST_PAGE = 'MEMBERSHIP_POOLS_LIST_PAGE';
export const MEMBERSHIP_POOLS_LIST_SORT = 'MEMBERSHIP_POOLS_LIST_SORT';
export const MEMBERSHIP_POOLS_LIST_FILTER_UPDATE = 'MEMBERSHIP_POOLS_LIST_FILTER_UPDATE';


// WEBPACK FOOTER //
// ./src/store/actions/types.js